/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Script from 'next/script';
import Style from './RastreadoresModal.css';

function RastreadoresModal({ sucesso, titulo, mensagem, onDismiss }) {
  return (
    <>
      <section id="rastreadores-Modal">
        <div className="modal-contain">
          {sucesso ? (
            <img
              className="img-modal"
              src="assets/rastreadores/ic_modal_sucesso.svg"
              alt="Icone de Sucesso"
            />
          ) : (
            <img
              className="img-modal"
              src="assets/rastreadores/ic_modal_erro.svg"
              alt="Icone de Erro"
            />
          )}

          <h2 id="titulo-modal">{titulo}</h2>
          <div
            dangerouslySetInnerHTML={{
              __html: `
              <p id="mensagem-modal">${mensagem}</p>
              `,
            }}
          />
          <div id="botao-modal" onClick={onDismiss}>
            Ok
          </div>
        </div>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default RastreadoresModal;
